import isEmpty from 'lodash/isEmpty';
import { useCallback, useEffect, useState } from 'react';
import { useScreeningDashboard } from './useScreeningDashboard';
import { useApplicationsList } from '../ApplicationsList/useApplicationsList';
import { ApplicationStatus } from '../../../shared/Constants';

export const useDashboardFilter = () => {
	const [isFilterApplied, setIsFilterApplied] = useState(false);
	const [selectedCardIndex, setSelectedCardIndex] = useState<number | null>(0);
	const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
	const { dashboardFilter, onDashboardFilterChange } = useScreeningDashboard();
	const { onFilterChange } = useApplicationsList({});

	useEffect(() => {
		setIsFilterApplied(!isEmpty(dashboardFilter));
	}, [dashboardFilter]);

	useEffect(() => {
		onFilterChange({
			status: [
				ApplicationStatus.FUNCTIONARY_ASSIGNED,
				ApplicationStatus.FUNCTIONARY_SUBMITTED,
				ApplicationStatus.WAITING_FOR_CARE_TEAM,
				ApplicationStatus.APPROVED,
				ApplicationStatus.REJECTED,
				ApplicationStatus.USER_SUBMITTED_APPLICATION,
			],
		});
		setSelectedCardIndex(0);
	}, [onFilterChange, setSelectedCardIndex]);

	const handleFilterPopup = () => {
		setIsFilterModalOpen(true);
	};

	const handleFilterModalClose = () => {
		setIsFilterModalOpen(false);
	};

	const handleResetFilters = useCallback(() => {
		onFilterChange({
			status: [
				ApplicationStatus.FUNCTIONARY_ASSIGNED,
				ApplicationStatus.FUNCTIONARY_SUBMITTED,
				ApplicationStatus.WAITING_FOR_CARE_TEAM,
				ApplicationStatus.APPROVED,
				ApplicationStatus.REJECTED,
				ApplicationStatus.USER_SUBMITTED_APPLICATION,
			],
		});
		onDashboardFilterChange({});
		setSelectedCardIndex(0);
	}, [onFilterChange, onDashboardFilterChange, setSelectedCardIndex]);

	return {
		dashboardFilter,
		isFilterApplied,
		isFilterModalOpen,
		selectedCardIndex,
		onDashboardFilterChange,
		handleFilterModalClose,
		handleFilterPopup,
		handleResetFilters,
	};
};
